'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/settings/templates/partials/subscription/receipt-item.hbs');

var SubscriptionReceiptItemView = ItemView.extend({
    template: template,

    tagName: 'tr',

    ui: {
        // updatePaymentMethod:    '[data-action="update-payment-method"]',
    },

    events: {
        // 'click @ui.updatePaymentMethod':    'updatePaymentMethod',
    },
});

module.exports = SubscriptionReceiptItemView;